<template>
	<div class="hd-mod-frame-encoded-v2 js-mod-frame-encoded-v2">
		<div class="hd-mod-frame-encoded-v2__backdrop" />
		<div class="hd-mod-frame-encoded-v2__content">
			<base-image-svg
				class="hd-mod-frame-encoded-v2-svg"
				:source="require('!html-loader!../../assets/svgs/13-mod-frame-encoded-v2.svg')"
			/>
			<lyra-asset
				class="hd-mod-frame-encoded-v2__content-caption" 
				asset-key="mod-encoded-caption" 
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.hd-mod-frame-encoded-v2 {
	position: absolute;
	@include box(100%);
	left: 0;

	&__backdrop {
		position: absolute;
		@include box(100%);
		background: rgba(0, 0, 0, 0.3);
		@include fade-out();
	}

	&__content {
		position: relative;
		@include box(100%);

		:deep() svg {
			position: absolute;
			right: 20px;
			bottom: 110px;
			@include fade-out();
		}

		&-caption {
			position: absolute;
			right: 20px;
			bottom: 70px;
			text-align: right;
			max-width: 650px;
			@include fade-out();

			:deep() p {
				font-size: em(12);
				line-height: em(18);
			}
		}
	}

	// Animation 
	&[data-state="animation-ready"] {
		.hd-mod-frame-encoded-v2__backdrop,
		.hd-mod-frame-encoded-v2__content-caption {
			opacity: 1;
		}

		.hd-mod-frame-encoded-v2-svg :deep() svg {
			opacity: 1;
		}
	}

	// Responsive 
	@include res-screen-small {
		&__content {
			:deep() svg {
				max-width: 650px;
				right: 50px;
			}

			&-caption {
				right: 50px;
				bottom: 100px;
				font-size: 14px;
			}
		}
	}

	@include res-screen-x-small {
		&__content {
			:deep() svg {
				max-width: 500px;
				bottom: 30px;
			}

			&-caption {
				max-width: 500px;
				bottom: 55px;
			}
		}
	}

	@include res-screen-portrait {
		&__content {
			:deep() svg {
				max-width: 80%;
				bottom: 150px;
				right: 40px;
			}

			&-caption {
				max-width: 500px;
				right: 40px;
				bottom: 130px;
			}
		}
	}

	@include res-screen-portrait-sm {
		top: 70%;

		&__backdrop {
			display: none;
		}

		&__content {
			:deep() svg {
				bottom: 80px;
			}

			&-caption {
				font-size: em(14);
				bottom: 110px;
			}
		}
	}
}
</style>